import React from "react";
import Page from "../../components/layouts/Page";
import TitleBar from "../../components/layouts/TitleBar";
import TabBar from "../../components/TabBar";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Class from "./Class/Class";
import Group from "./Group/Group";
import Money from "./Money/Money";
import Passport from "./Passport/Passport";
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    padding: "0rem 0 2rem 0",
    minHeight: "70vh",
  },
}));

const Downloads = () => {
  const classes = useStyles();
  let { path, url } = useRouteMatch();
  return (
    <Page title="表單下載" className={classes.root}>
      <TitleBar mainTitle="表單下載" subTitle="Downloads"></TitleBar>
      <TabBar
        default="passport"
        hierarchy="2"
        tabs={[
          {
            label: "學生學習護照",
            value: "passport",
            linkto: `${url}/passport`,
          },
          { label: "服務學習課程", value: "class", linkto: `${url}/class` },
          { label: "學生自主團隊", value: "group", linkto: `${url}/group` },
          { label: "獎學金", value: "money", linkto: `${url}/money` },
        ]}
      />
      <div className="tabPanel">
        <Switch>
          <Route path={path} exact component={Passport} />
          <Route path={`${path}/passport`} component={Passport} />
          <Route path={`${path}/class`} component={Class} />
          <Route path={`${path}/group`} component={Group} />
          <Route path={`${path}/money`} component={Money} />
        </Switch>
      </div>
    </Page>
  );
};

export default Downloads;
